/**
 * Platform sniffing for smart-link routing.
 * Extracted from SmartRedirect.tsx so it can be unit-tested without rendering
 * the whole component.
 */

export type Platform = 'ios' | 'android' | 'desktop';

interface DetectInput {
  userAgent: string;
  /** Whether `'ontouchend' in document` evaluates true. iPadOS 13+ reports as
   *  Mac but with touch, so we treat that as iOS. */
  hasTouch?: boolean;
}

export function detectPlatformFrom({ userAgent, hasTouch = false }: DetectInput): Platform {
  if (/iPad|iPhone|iPod/.test(userAgent)) return 'ios';
  if (/Macintosh/.test(userAgent) && hasTouch) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return 'desktop';
}

export function detectPlatform(): Platform {
  if (typeof window === 'undefined') return 'desktop';
  const userAgent = window.navigator.userAgent || '';
  const hasTouch = typeof document !== 'undefined' && 'ontouchend' in document;
  return detectPlatformFrom({ userAgent, hasTouch });
}
